import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'
import ManageShiftEntriesSmartview from 'widgets/shifts/ManageShiftEntriesSmartview'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export default function WageRatioTable () {
  return (
    <ValueToCollection name='table'>
      <ForEachModel>
        <UI.Card tight className='pt-6 sm:pt-10'>
          <UI.CardHeader withPadding>
            <UI.SecondaryHeading>
              <Displays.Text name='key'/>
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='collection'>
            <Table
              striped
              withFooter
              extraHeader={(
                <tr>
                  <th/>
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.waiter'/>
                    </UI.Text>
                  </th>
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.kitchen'/>
                    </UI.Text>
                  </th>
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.dishwasher'/>
                    </UI.Text>
                  </th>
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.wage_cost'/>
                    </UI.Text>
                  </th>
                  <th colSpan={1} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.revenue'/>
                    </UI.Text>
                  </th>
                  <th colSpan={2} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='generic.wage_ratio'/>
                    </UI.Text>
                  </th>
                  {/*
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.budgeted_wage_ratio' />
                    </UI.Text>
                  </th>
                  <th colSpan={3} className='border-l'>
                    <UI.Text color='primary' weight='medium' size='xs' uppercase>
                      <Translation name='columns.realized_wage_ratio' />
                    </UI.Text>
                  </th>

                  */}
                </tr>
              )}
            >

              <Columns.Column
                label={(
                  <UI.DoubleTableHead>
                    <Translation name='generic.weekday'/>
                  </UI.DoubleTableHead>
                )}
                footer={<Translation name='generic.total'/>}
              >
                <UI.Text weight='medium'>
                  <Displays.Date name='carbonDate' dateFormat='ddd D. MMM YYYY'/>
                </UI.Text>
              </Columns.Column>

              <Columns.Column
                label='Normal'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='waiter_normal_hours'
                    display={<Displays.Number/>}
                  />
                )}
                className='border-l'
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='waiter' type='normal'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='waiter_normal_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Adm.'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='waiter_admin_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='waiter' type='admin'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='waiter_admin_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Total'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='waiter_total_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick smartview={<ManageShiftEntriesSmartview location='waiter'/>}
                                                replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='waiter_total_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>

              <Columns.Column
                label='Normal'
                alignment='center'
                className='border-l'
                footer={(
                  <Displays.Aggregate
                    name='kitchen_normal_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='kitchen' type='normal'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='kitchen_normal_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Adm.'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='kitchen_admin_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='kitchen' type='admin'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='kitchen_admin_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Total'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='kitchen_total_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick smartview={<ManageShiftEntriesSmartview location='kitchen'/>}
                                                replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='kitchen_total_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>

              <Columns.Column
                label='Normal'
                alignment='center'
                className='border-l'
                footer={(
                  <Displays.Aggregate
                    name='dishwasher_normal_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='cleaning' type='normal'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='dishwasher_normal_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Adm.'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='dishwasher_admin_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick
                  smartview={<ManageShiftEntriesSmartview location='cleaning' type='admin'/>} replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='dishwasher_admin_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>
              <Columns.Column
                label='Total'
                alignment='center'
                footer={(
                  <Displays.Aggregate
                    name='dishwasher_total_hours'
                    display={<Displays.Number/>}
                  />
                )}
              >
                <MountSmartviewWithModelOnClick smartview={<ManageShiftEntriesSmartview location='cleaning'/>}
                                                replace={false}>
                  <UI.Text className='cursor-pointer'>
                    <Displays.Number name='dishwasher_total_hours'/>
                  </UI.Text>
                </MountSmartviewWithModelOnClick>
              </Columns.Column>

              <Columns.CompactNumber
                name='waiter_wage_cost'
                label={<Translation name='generic.waiter'/>}
                aggregate='sum'
                alignment='center'
                className='border-l'
              />
              <Columns.CompactNumber
                name='kitchen_wage_cost'
                label={<Translation name='generic.kitchen'/>}
                aggregate='sum'
                alignment='center'
              />
              <Columns.CompactNumber
                name='total_wage_cost'
                label={<Translation name='generic.total'/>}
                aggregate='sum'
                alignment='center'
              />

              <Columns.CompactNumber
                name='revenue'
                label={<Translation name='generic.total'/>}
                aggregate='sum'
                alignment='center'
                className='border-l'
              />

              {/*

              <Columns.WageRatio
                name='budgeted_waiter_wage_ratio'
                label={<Translation name='generic.waiter' />}
                alignment='right'
                className='border-l'
                footer={(
                  <Displays.AggregateRatio
                    outOfName='budgeted_waiter_wage_ratio_revenue'
                    name='budgeted_waiter_wage_ratio_expenses'
                    display={<Displays.WageRatio />}
                  />
                )}
              />
              <Columns.WageRatio
                name='budgeted_kitchen_wage_ratio'
                label={<Translation name='generic.kitchen' />}
                alignment='right'
                footer={(
                  <Displays.AggregateRatio
                    name='budgeted_kitchen_wage_ratio_expenses'
                    outOfName='budgeted_kitchen_wage_ratio_revenue'
                    display={<Displays.WageRatio />}
                  />
                )}
              />
              <Columns.WageRatio
                name='budgeted_wage_ratio'
                label={<Translation name='generic.total' />}
                alignment='right'
                footer={(
                  <Displays.AggregateRatio
                    name='budgeted_wage_ratio_expenses'
                    outOfName='budgeted_wage_ratio_revenue'
                    display={<Displays.WageRatio />}
                  />
                )}
              />

              <Columns.WageRatio
                name='realized_waiter_wage_ratio'
                label={<Translation name='generic.waiter' />}
                alignment='right'
                className='border-l'
                footer={(
                  <Displays.AggregateRatio
                    outOfName='realized_waiter_wage_ratio_revenue'
                    name='realized_waiter_wage_ratio_expenses'
                    display={<Displays.WageRatio />}
                  />
                )}
              />
              <Columns.WageRatio
                name='realized_kitchen_wage_ratio'
                label={<Translation name='generic.kitchen' />}
                alignment='right'
                footer={(
                  <Displays.AggregateRatio
                    name='realized_kitchen_wage_ratio_expenses'
                    outOfName='realized_kitchen_wage_ratio_revenue'
                    display={<Displays.WageRatio />}
                  />
                )}
              />
              <Columns.WageRatio
                name='realized_wage_ratio'
                label={<Translation name='generic.total' />}
                alignment='right'
                footer={(
                  <Displays.AggregateRatio
                    name='realized_wage_ratio_expenses'
                    outOfName='realized_wage_ratio_revenue'
                    display={<Displays.WageRatio />}
                  />
                )}
              />

              */}

              <Columns.WageRatio
                name='budgeted_wage_ratio'
                label={<Translation name='columns.shifts_plan'/>}
                alignment='center'
                className='border-l'
                footer={(
                  <Displays.AggregateRatio
                    name='budgeted_wage_ratio_expenses'
                    outOfName='realized_wage_ratio_revenue'
                    display={<Displays.WageRatio/>}
                  />
                )}
              />
              <Columns.WageRatio
                name='realized_wage_ratio'
                label={<Translation name='generic.realized'/>}
                alignment='center'
                footer={(
                  <Displays.AggregateRatio
                    name='total_wage_cost'
                    outOfName='realized_wage_ratio_revenue_vat'
                    display={<Displays.WageRatio/>}
                  />
                )}
              />

            </Table>
          </ValueToCollection>
        </UI.Card>
      </ForEachModel>
    </ValueToCollection>
  )
}
